import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
} from 'reactstrap';
import { toast } from 'react-toastify';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import BusinessApi from 'apis/Business';
import { FACEBOOK, INSTAGRAM, TWITTER } from 'constants/SocialMedias';

import SocialMediaConfig from './social-media/SocialMediaConfig';
import SocialMediaMessage from './social-media/SocialMediaMessage';
import Toaster from '../../../Toaster';

const DEFAULT_MESSAGE = `We here at {businessName} appreciate the review you left on our
survey. We would be thrilled if you keep in touch with us on social media.`;

class SocialMediaAddOnModal extends Component {
  constructor() {
    super();
    this.state = {
      facebookActive: false,
      instagramActive: false,
      twitterActive: false,
      facebook: {},
      instagram: {},
      twitter: {},
      customMessage: '',
    };
  }

  componentDidMount() {
    const { data, socialMediaAddon, businessName } = this.props;
    const facebookData = data.find(dt => dt.media_type === FACEBOOK.type);
    const twitterData = data.find(dt => dt.media_type === TWITTER.type);
    const instagramData = data.find(dt => dt.media_type === INSTAGRAM.type);
    const { custom_message } = socialMediaAddon || {};
    const customMessage = custom_message
      ? custom_message
      : DEFAULT_MESSAGE.replace('{businessName}', businessName);

    this.setState({
      facebook: facebookData || {},
      twitter: twitterData || {},
      instagram: instagramData || {},
      facebookActive: facebookData ? facebookData.is_active : false,
      twitterActive: twitterData ? twitterData.is_active : false,
      instagramActive: instagramData ? instagramData.is_active : false,
      customMessage,
    });
  }

  activateFacebook = () => {
    this.setState(prevState => ({
      facebookActive: !prevState.facebookActive,
    }));
  };

  activateTwitter = () => {
    this.setState(prevState => ({
      twitterActive: !prevState.twitterActive,
    }));
  };

  activateInstagram = () => {
    this.setState(prevState => ({
      instagramActive: !prevState.instagramActive,
    }));
  };

  updateContent = (type, data) => {
    this.setState({
      [type]: data,
    });
  };

  save = () => {
    const { facebook, twitter, instagram } = Object.assign(this.state, {});
    const {
      facebookActive,
      instagramActive,
      twitterActive,
      customMessage,
    } = this.state;

    facebook.is_active = facebookActive;
    twitter.is_active = twitterActive;
    instagram.is_active = instagramActive;

    const { businessId, toggleModal, socialMediaAddon } = this.props;

    const socialMediasAttributes = [facebook, twitter, instagram].filter(
      x => Object.keys(x).length > 1 && x.title && x.link
    );

    const { id: socialMediaAddonId } = socialMediaAddon || {};

    const businessAddonsAttributes = [
      {
        id: socialMediaAddonId,
        custom_message: customMessage || '',
      },
    ];

    if (socialMediasAttributes.length < 1) return;

    const updatedData = {
      business: {
        social_medias_attributes: socialMediasAttributes,
        business_addons_attributes: businessAddonsAttributes,
      },
    };

    BusinessApi.update(businessId, updatedData)
      .then(() => {
        toggleModal();
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" /> Successfully updated
            configuration.
          </div>
        ));
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" /> Error while
              fetching data
            </div>
          )),
          console.log(e)
        )
      );
  };

  onCustomMessageChange = message => {
    const { customMessage } = this.state;
    const { businessId, socialMediaAddon } = this.props;
    const { id: socialMediaAddonId } = socialMediaAddon || {};
    const businessAddonsAttributes = [
      {
        id: socialMediaAddonId,
        custom_message: message,
      },
    ];
    const updatedData = {
      business: {
        business_addons_attributes: businessAddonsAttributes,
      },
    };
    BusinessApi.update(businessId, updatedData)
      .then(() => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Custom Message Updated Successfully'
        );
        this.setState({ customMessage: message });
      })
      .catch(e => {
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Failed to update custom message'
        );
        this.setState({ customMessage });
      });
  };

  render() {
    const { toggleModal, isVisible, title, type } = this.props;
    const {
      facebook,
      twitter,
      instagram,
      customMessage,
      facebookActive,
      instagramActive,
      twitterActive,
    } = this.state;

    return (
      <React.Fragment>
        <Modal className="select-metrics-modal" isOpen={isVisible}>
          <ModalHeader toggle={toggleModal}>
            <div className="metric-title">
              <span className="w-100 float-left">Social media growth add-ons</span>
            </div>
          </ModalHeader>

          <ModalBody>
            <SocialMediaMessage
              updateContent={this.updateContent}
              onCustomMessageChange={this.onCustomMessageChange}
              type={type}
              message={customMessage}
            />
            <SocialMediaConfig
              data={FACEBOOK}
              showSocialMedia={facebookActive}
              toggleSocialMedia={this.activateFacebook}
              updateContent={this.updateContent}
              type={type}
              values={facebook}
            />
            <SocialMediaConfig
              data={INSTAGRAM}
              showSocialMedia={instagramActive}
              toggleSocialMedia={this.activateInstagram}
              updateContent={this.updateContent}
              type={type}
              values={instagram}
            />
            <SocialMediaConfig
              data={TWITTER}
              showSocialMedia={twitterActive}
              toggleSocialMedia={this.activateTwitter}
              updateContent={this.updateContent}
              type={type}
              values={twitter}
            />
          </ModalBody>
          <ModalFooter className="d-block">
            <ButtonGroup className="float-right">
              <Button className="btn-cancel" onClick={toggleModal}>
                Cancel
              </Button>
              <Button className="btn-success" onClick={this.save}>
                Save Network
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

SocialMediaAddOnModal.defaultProps = {
  toggleModal: () => {},
  isVisible: false,
};

SocialMediaAddOnModal.propTypes = {
  toggleModal: PropTypes.func,
  isVisible: PropTypes.bool,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired,
  socialMediaAddon: PropTypes.shape({
    id: PropTypes.number,
    custom_message: PropTypes.string,
  }).isRequired,
};

export default SocialMediaAddOnModal;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/info-edit/SocialMediaAddOnModal.js